import { jsx } from "react/jsx-runtime";
import { c } from "react-compiler-runtime";
import { Suspense, forwardRef, useContext } from "react";
import classnames from "classnames";
import { WysiwygContext } from "../../../context/index.js";
import { Skeleton } from "../../../../../Skeleton/index.js";
import { getActivePlayer } from "./helpers/index.js";
import { Player } from "./Players/index.js";
import { useStyles } from "./ReactPlayer.styles.js";
function _define_property(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if ("function" == typeof Object.getOwnPropertySymbols) ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ReactPlayer_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = null != source ? source : {};
    if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    else ReactPlayer_ownKeys(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
    return target;
}
const defaultProps = {
    src: '',
    width: '100%',
    height: '536px',
    volume: 1,
    playbackRate: 1
};
const ReactPlayer = /*#__PURE__*/ forwardRef((props, ref)=>{
    var _player_player;
    var _combinedProps_config;
    const $ = c(3);
    const { envVars } = useContext(WysiwygContext);
    const combinedProps = _object_spread({}, defaultProps, props);
    const { style, width, height, wrapper, src, slot, className } = combinedProps;
    const { classes } = useStyles({
        width,
        height
    });
    const player = getActivePlayer(envVars.allowDirectVideoLinks, src);
    if (!player) return null;
    const config = null == (_combinedProps_config = combinedProps.config) ? void 0 : _combinedProps_config[player.key];
    let t0;
    if ($[0] !== props.height || $[1] !== props.width) {
        t0 = /*#__PURE__*/ jsx(Skeleton, {
            height: props.height,
            width: props.width,
            variant: "rect"
        });
        $[0] = props.height;
        $[1] = props.width;
        $[2] = t0;
    } else t0 = $[2];
    return /*#__PURE__*/ jsx(Suspense, {
        fallback: t0,
        children: /*#__PURE__*/ jsx(Player, _object_spread_props(_object_spread({}, combinedProps), {
            ref: ref,
            activePlayer: null != (_player_player = player.player) ? _player_player : player,
            slot: wrapper ? void 0 : slot,
            className: wrapper ? classes.player : classnames([
                classes,
                className
            ]),
            style: wrapper ? void 0 : style,
            config: config
        }))
    });
});
export { ReactPlayer, defaultProps };
